import { DeliveryType, FulfillmentType } from '../../../core/models/order.model';

export class FulfillmentTypeItem {
  constructor(
    public title: string = null,
    public icon: string = null,
    public wideIcon: boolean = false,
    public type: FulfillmentType = FulfillmentType.PICKUP,
    public minAmount: number = null,
    public maxAmount: number = null
  ) {
  }
}

export interface DeliveryTypeItem {
  title: string;
  icon: string;
  wideIcon?: boolean;
  type: DeliveryType;
  minAmount?: number;
  maxAmount?: number;
}
